var React = require('react');

function FacebookColor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.7275 2.19531H15.7275C14.4015 2.19531 13.1297 2.7221 12.192 3.65978C11.2543 4.59746 10.7275 5.86923 10.7275 7.19531V10.1953H7.72754V14.1953H10.7275V22.1953H14.7275V14.1953H17.7275L18.7275 10.1953H14.7275V7.19531C14.7275 6.9301 14.8329 6.67574 15.0204 6.48821C15.208 6.30067 15.4623 6.19531 15.7275 6.19531H18.7275V2.19531Z","stroke":"#92210F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

FacebookColor.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = FacebookColor;

FacebookColor.default = FacebookColor;
